export const getAmount = (centAmount = 0, fractionDigits = 0) => {
  if (centAmount === 0) {
    return 0
  }
  return centAmount / Math.pow(10, fractionDigits)
}
